<template>
  <EkitabuTextArea
    v-bind="{ ...$props, ...$attrs }"
    v-model="localValue"
    :label-style="labelStyle"
    :disabled="disabled"
    :loading="isUpdating"
    :has-error="hasError"
    :show-success="showSuccess"
    @input="onInput"
  />
</template>

<script>
import EkitabuTextArea from '@/components/EkitabuTextArea.vue';
import ProductInfoFieldMixin from '@/mixins/ProductInfoFieldMixin';

export default {
  name: 'LocalBookTextArea',
  components: { EkitabuTextArea },
  mixins: [ProductInfoFieldMixin],
  inheritAttrs: false,
  props: {
    id: { type: String, required: true },
    label: { type: String, default: '' },
    labelStyle: { type: String, default: null },
    required: { type: Boolean, default: false },
    rules: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
};
</script>
